import { Skeleton, styled as muiStyled } from '@mui/material';

export const CustomSkeleton = muiStyled(Skeleton)(() => ({
  background: 'transparent',
  transform: 'unset',
  height: '100%',
}));
